import CouponsMap from "@/entities/Coupons/CouponsMap";

const CouponsExpiredMap = {
  ...CouponsMap,
  Plural: "Expired Coupons",
  InitialFilters: null,
  Filters: [],
};

export default CouponsExpiredMap;
